import update from 'immutability-helper';
import SessionListActionTypeEnum from './SessionListConstants';

const initialState = {
  expandedSession: '0',
  searchTerm: '',
  sessionList: [],
  sessionsToDelete: [],
};

const SessionListStateHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SessionListActionTypeEnum.DOCUMENT_SESSION_SELECT:
      return update(state, {
        sessionsToDelete: {
          $push: [{
            docListItemId: action.docListItemId,
            documentType: action.documentType,
            documentName: action.documentName,
            key: action.key,
          }],
        },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_DESELECT:
      return update(state, {
        sessionsToDelete: {
          $set: state.sessionsToDelete.filter(el => el.docListItemId !== action.docListItemId),
        },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_DESELECT_ALL:
      return update(state, {
        sessionsToDelete: {
          $set: [],
        },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ADD:
      return update(state, {
        sessionList: { $set: action.sessionList.map((session) => {
          const sessionToEdit = session;
          sessionToEdit.isInSearchFilter = true;
          return sessionToEdit;
        }),
        },
      });


    case SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ITEM_ADD: {
      const item = action.item;
      return update(state, {
        sessionList: { $splice: [[0, 0, item]] },
      });
    }
    case SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_ITEM_UPDATE: {
      const idx = action.idx;
      return update(state, {
        sessionList: {
          [idx]: {
            $merge: action.updatedAttributes,
          },
        },
      });
    }
    case SessionListActionTypeEnum.DOCUMENT_SESSION_REMOVE:
      return update(state, {
        sessionList: {
          $set: state.sessionList.filter((el) => {
            // el.id is a number but docListItemId is a string.
            // If el.id is present, let's typecast to string before we compare.
            const elId = el.id ? el.id.toString() : null;
            return (elId || el.document_type) !== action.docListItemId;
          }),
        },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_EDIT:
      return update(state, {
        sessionList: {
          $set: state.sessionList.map((session) => {
            const sessionId = session.id ? session.id.toString() : session.document_type.toString();
            const sessionToEdit = session;

            if (sessionId === action.sessionId) {
              sessionToEdit[action.documentNameKey] = action.documentName;
            }
            return sessionToEdit;
          }),
        },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_EXPAND:
      return update(state, {
        expandedSession: { $set: action.expandKey },
      });
    case SessionListActionTypeEnum.DOCUMENT_SESSION_LIST_SEARCH_TERM_SET:
      return update(state, {
        searchTerm: { $set: action.searchTerm },
        sessionList: { $set: state.sessionList.map((session) => {
          const sessionToEdit = session;
          const searchTerm = action.searchTerm.replace(/-/g, ' ').toLowerCase();
          const { name, document_name: documentName, document_type: documentType } = sessionToEdit;

          sessionToEdit.isInSearchFilter = false;

          if (!documentName) {
            if (
              name &&
              name.replace(/-/g, ' ').toLowerCase().includes(searchTerm)
            ) {
              sessionToEdit.isInSearchFilter = true;
            }

            if (
              documentType &&
              documentType.length < 32 &&
              documentType.replace(/-/g, ' ').toLowerCase().includes(searchTerm)
            ) {
              sessionToEdit.isInSearchFilter = true;
            }
          } else if (documentName.toLowerCase().includes(searchTerm)) {
            sessionToEdit.isInSearchFilter = true;
          }

          return sessionToEdit;
        }),
        },
      });
    default:
      return state;
  }
};

export default SessionListStateHandler;



// WEBPACK FOOTER //
// ./src-react/SessionList/SessionListReducer.jsx